import * as Sentry from '@sentry/vue'
import { ResponseError } from '~/composables/custom-fetch'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  if (config.public.sentryEnvironment === 'local') return

  const { isAccepted } = useCookieConsent()
  if (!isAccepted.value) return

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: config.public.sentryDsn,
    environment: config.public.sentryEnvironment,
    integrations: [
      Sentry.browserTracingIntegration({ router: useRouter() }),
      Sentry.replayIntegration(),
      Sentry.captureConsoleIntegration({ levels: ['error'] }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.01,
    // APIクライアント層でHTTP応答ありのエラーをSentry送信から除外する。
    // 4xx は UI 側で表示処理済みの業務エラー、5xx は CloudWatch（バックエンドログ）で
    // 検出されるため Sentry に送ると重複ノイズになる。判定軸はResponseError（=HTTP応答あり）。
    beforeSend(event, hint) {
      const exception = hint?.originalException
      // fetch ラッパーが直接投げる ResponseError
      if (exception instanceof ResponseError) return null
      // createError で包み直された API エラーも statusCode で拾って除外する。
      // 注: フロント側で意図的に statusCode>=400 を投げている箇所も巻き込む（許容済み）。
      const statusCode = (exception as { statusCode?: unknown } | undefined)?.statusCode
      if (typeof statusCode === 'number' && statusCode >= 400) return null
      return event
    },
    ignoreErrors: [
      // サードパーティスクリプト由来の未定義参照
      "Can't find variable: YAHOO",
      "Can't find variable: EmptyRanges",
      // ブラウザ拡張由来
      'Invalid call to runtime.sendMessage',
      // Android WebView 由来
      'Java object is gone',
      // iOS Chrome の window.print オーバーライド実装由来
      /window\.webkit\.messageHandlers\.print/,
    ],
  })
})
